import {
  HomeIcon,
  ListBulletIcon,
  MapPinIcon,
  UserCircleIcon,
  UserGroupIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import { IconNames } from "components/Icon/Icon";
import SupportIcon from "components/Icon/icons/SupportIcon";

export type IMenuChild = {
  id: string;
  label: string;
  Icon: any;
  disableBoard?: boolean;
  add?: boolean;
  addRightType?: string;
  addRightKey?: string;
  addRightKeyJoker?: string[];
  useWordingPlural?: boolean;
};
export type IMenuGroup = {
  label: string;
  children: IMenuChild[];
  icon: IconNames;
  useWordingPlural?: boolean;
  ignoreGroup?: boolean;
};

export type IMenuConf = Record<string, IMenuGroup>;

/** ******************************** Items ********************************** */
const dashboardItem = {
  id: "./",
  label: "board",
  Icon: HomeIcon,
  disableBoard: true,
};

const plotItem = {
  id: "plots",
  label: "plots",
  Icon: MapPinIcon,
  add: true,
};

const zoneItem = {
  id: "zones",
  label: "zones",
  Icon: MapPinIcon,
  add: true,
};

const stepItem = {
  id: "steps",
  label: "steps",
  Icon: ListBulletIcon,
  add: true,
};

const reviewItem = {
  id: "reviews",
  label: "reviews",
  Icon: MapPinIcon,
  add: true,
};

const contactItem = {
  id: "contacts",
  label: "contacts",
  Icon: MapPinIcon,
};

const farmerItem = {
  id: "farmers",
  label: "farmers",
  Icon: UserGroupIcon,
};

const usersItem = {
  id: "users",
  label: "users",
  Icon: UsersIcon,
  add: true,
  addRightType: "role",
  addRightKey: "isAdmin",
};

const mySpaceItem = {
  id: "my-account",
  label: "myAccount",
  Icon: UserCircleIcon,
};

/** ******************************** Sections ******************************* */

const homeSection: IMenuConf = {
  home: {
    label: "",
    icon: "MdOutlineChecklist",
    ignoreGroup: true,
    children: [dashboardItem, plotItem, zoneItem, reviewItem, contactItem, farmerItem, stepItem],
  },
};

const manageSection: IMenuConf = {
  gestion: {
    label: "manage",
    icon: "GiMineTruck",
    children: [

    ],
  },
};

const paramsSection: IMenuConf = {
  reglages: {
    label: "params",
    icon: "VcsSettings",
    children: [stepItem],
  },
};

const usersSection: IMenuConf = {
  accounts: {
    label: "accounts",
    icon: "UserIcon",
    children: [usersItem],
  },
};

const helpSection: IMenuConf = {
  aide: {
    label: "help",
    icon: "IoColorPaletteOutline",
    children: [],
  },
};

/** **********************************  Menus by roles ************************** */

export const getProMenu = (): IMenuConf => ({
  reglages: {
    label: "params",
    icon: "VcsSettings",
    children: [mySpaceItem],
  },
});

export const getMonitoringMenu = (): IMenuConf => ({
  home: {
    label: "",
    icon: "MdOutlineChecklist",
    ignoreGroup: true,
    children: [
      dashboardItem,
      { ...plotItem, add: false },
      { ...zoneItem, add: false },
      { ...reviewItem, add: false },
      contactItem,
      farmerItem,
    ],
  },
  reglages: {
    label: "params",
    icon: "VcsSettings",
    children: [mySpaceItem],
  },
});

export const getSuperadminRootMenu = (): IMenuConf => ({
  ...homeSection,
  ...usersSection,
  reglages: {
    label: "params",
    icon: "VcsSettings",
    children: [mySpaceItem],
  },
});

export const getSuperadminFilteredMenu = (): IMenuConf => ({
  ...homeSection,
  ...manageSection,
  ...paramsSection,
  ...usersSection,
  ...helpSection,
});
